import { useEffect, useState } from 'react';

/**
 * Acompanha uma media query e re-renderiza quando ela muda.
 *
 * O projeto não usa as classes responsivas do Tailwind (o CSS é escrito à mão
 * em index.css), então o layout depende de medir a largura no JavaScript. Ler
 * `window.innerWidth` direto no render não basta: girar o tablet ou
 * redimensionar a janela não dispara nova renderização.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);

    setMatches(mql.matches); // a query pode ter mudado entre o render e o efeito
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
